export const SEO_COPY_HIDDEN = 0;
export const SEO_COPY_TOP_COLLAPSED = 1;
export const SEO_COPY_BOTTOM_COLLAPSED = 2;
export const SEO_COPY_BOTTOM_EXPANDED = 3;
